export default {
  download: 'Download',
} as const;
